<template>
  <div class="ai-work">
    <!-- 顶部标题栏 -->
    <header class="ai-work__header">
      <div class="ai-work__heading">
        <h1 class="ai-work__title">1688AI工作台</h1>
        <p class="ai-work__subtitle">AI智能选品，对话式采购助手</p>
      </div>
      <div class="ai-work__header-actions">
        <div class="ai-work__balance">算力余额 <b>8,250</b></div>
        <button type="button" class="ai-work__recharge">充值</button>
      </div>
    </header>

    <div class="ai-work__body">
      <!-- 左侧对话区 -->
      <section class="ai-chat">
        <div class="ai-chat__top">
          <div class="ai-chat__assistant">
            <div class="ai-chat__assistant-avatar">
              <span class="ai-chat__robot">🤖</span>
              <i class="ai-chat__online-dot"></i>
            </div>
            <div class="ai-chat__assistant-info">
              <div class="ai-chat__assistant-name">观星树AI选品助手</div>
              <div class="ai-chat__assistant-status"><i></i>在线</div>
            </div>
          </div>
          <a class="ai-chat__clear" @click="clearChat">清空对话</a>
        </div>

        <div ref="messageBox" class="ai-chat__messages">
          <!-- 欢迎语 -->
          <div class="ai-msg">
            <div class="ai-msg__avatar ai-msg__avatar--bot">🤖</div>
            <div class="ai-msg__main">
              <div class="ai-msg__meta">
                <span class="ai-msg__name">观星树AI</span>
                <span class="ai-msg__time">03:15</span>
              </div>
              <div class="ai-msg__bubble ai-msg__bubble--bot">
                <p>您好！我是观星树AI选品助手。您可以：</p>
                <p>1. 输入关键词，我帮您找货</p>
                <p>2. 上传图片，我帮您以图搜货</p>
                <p>3. 描述需求，我帮您推荐商品</p>
                <p class="ai-msg__ask">请问您想找什么商品？</p>
              </div>
            </div>
          </div>

          <!-- 用户消息 -->
          <div class="ai-msg ai-msg--user">
            <div class="ai-msg__main">
              <div class="ai-msg__meta ai-msg__meta--user">
                <span class="ai-msg__name ai-msg__name--user">我</span>
                <span class="ai-msg__time">03:16</span>
              </div>
              <div class="ai-msg__bubble ai-msg__bubble--user">帮我找夏季女装连衣裙，价格50-100元</div>
            </div>
            <div class="ai-msg__avatar ai-msg__avatar--user">王</div>
          </div>

          <!-- 商品推荐结果 -->
          <div class="ai-msg">
            <div class="ai-msg__avatar ai-msg__avatar--bot">🤖</div>
            <div class="ai-msg__main">
              <div class="ai-msg__meta">
                <span class="ai-msg__name">观星树AI</span>
                <span class="ai-msg__time">03:16</span>
              </div>
              <div class="ai-msg__bubble ai-msg__bubble--bot">
                好的！为您搜索「夏季女装连衣裙」，价格区间50-100元。找到以下商品：
              </div>
              <div class="ai-goods">
                <div v-for="goods in goodsList" :key="goods.id" class="ai-goods__item">
                  <div class="ai-goods__img"><span>{{ goods.icon }}</span></div>
                  <div class="ai-goods__title">{{ goods.title }}</div>
                  <div class="ai-goods__price">¥{{ goods.price }}</div>
                  <button type="button" class="ai-goods__add">加入云商品库</button>
                </div>
              </div>
              <a class="ai-chat__more">查看更多结果 →</a>
            </div>
          </div>

          <!-- AI分析 -->
          <div class="ai-msg">
            <div class="ai-msg__avatar ai-msg__avatar--bot">🤖</div>
            <div class="ai-msg__main">
              <div class="ai-msg__meta">
                <span class="ai-msg__name">观星树AI</span>
                <span class="ai-msg__time">03:17</span>
              </div>
              <div class="ai-msg__bubble ai-msg__bubble--bot ai-msg__bubble--analysis">
                <span class="ai-msg__bulb">💡</span>
                <span><b>AI分析：</b>当前连衣裙市场热门风格为法式碎花、气质收腰。建议关注50-80元价格带，转化率最高。是否需要我生成选品报告？</span>
              </div>
              <div class="ai-msg__actions">
                <button type="button" class="ai-btn ai-btn--gold" @click="reportDialogVisible = true">生成选品报告</button>
                <button type="button" class="ai-btn ai-btn--plain">继续搜索</button>
              </div>
            </div>
          </div>
        </div>

        <!-- 输入栏 -->
        <div class="ai-chat__input">
          <button type="button" class="ai-chat__input-icon" title="上传图片" @click="imgDialogVisible = true">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="3"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <path d="M21 15l-5-5L5 21"></path>
            </svg>
          </button>
          <button type="button" class="ai-chat__input-icon" title="语音输入">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
              <rect x="9" y="3" width="6" height="11" rx="3"></rect>
              <path d="M5 11a7 7 0 0 0 14 0"></path>
              <path d="M12 18v3"></path>
            </svg>
          </button>
          <input v-model.trim="inputText" class="ai-chat__input-field" type="text" placeholder="输入您的需求，如：找夏季T恤男，价格20-50元" @keyup.enter="sendMessage" />
          <button type="button" class="ai-chat__send" @click="sendMessage">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14"></path>
              <path d="M13 6l6 6-6 6"></path>
            </svg>
          </button>
        </div>
      </section>

      <!-- 右侧信息栏 -->
      <aside class="ai-aside">
        <!-- AI热门推荐 -->
        <section class="ai-panel">
          <div class="ai-panel__head">
            <div class="ai-panel__title"><span class="ai-panel__icon ai-panel__icon--fire">🔥</span>AI热门推荐</div>
            <a class="ai-panel__link">换一批</a>
          </div>
          <div class="ai-panel__body">
            <div v-for="item in hotList" :key="item.id" class="ai-hot">
              <div class="ai-hot__img">{{ item.icon }}</div>
              <div class="ai-hot__info">
                <div class="ai-hot__title">{{ item.title }}</div>
                <div class="ai-hot__price">¥{{ item.price }}</div>
              </div>
              <button type="button" class="ai-hot__btn">找同款</button>
            </div>
          </div>
        </section>

        <!-- 市场趋势 -->
        <section class="ai-panel">
          <div class="ai-panel__head">
            <div class="ai-panel__title"><span class="ai-panel__icon">📈</span>市场趋势</div>
          </div>
          <div class="ai-panel__body">
            <div class="ai-trend__tags">
              <span v-for="tag in trendTags" :key="tag.name" class="ai-trend__tag" :class="'ai-trend__tag--' + tag.type">{{ tag.name }}</span>
            </div>
            <div class="ai-trend__time">更新时间：2024-06-29 15:00</div>
          </div>
        </section>

        <!-- 最近搜索 -->
        <section class="ai-panel">
          <div class="ai-panel__head">
            <div class="ai-panel__title"><span class="ai-panel__icon">🕐</span>最近搜索</div>
            <a class="ai-panel__link">清空记录</a>
          </div>
          <div class="ai-panel__body">
            <div v-for="record in recentList" :key="record.id" class="ai-recent">
              <span class="ai-recent__keyword">{{ record.keyword }}</span>
              <span class="ai-recent__time">{{ record.time }}</span>
            </div>
          </div>
        </section>

        <!-- AI算力消耗 -->
        <section class="ai-panel">
          <div class="ai-panel__head">
            <div class="ai-panel__title"><span class="ai-panel__icon ai-panel__icon--bolt">⚡</span>AI算力消耗</div>
          </div>
          <div class="ai-panel__body">
            <div class="ai-power__used">
              <span>本月已用</span>
              <b>1,750 <em>/ 10,000</em></b>
            </div>
            <div class="ai-power__bar">
              <i :style="{ width: '17.5%' }"></i>
            </div>
            <div class="ai-power__list">
              <div v-for="power in powerList" :key="power.name" class="ai-power__row">
                <span>{{ power.name }}</span>
                <span>{{ power.value }}</span>
              </div>
            </div>
            <a class="ai-panel__link ai-power__detail">查看明细 →</a>
          </div>
        </section>
      </aside>
    </div>

    <!-- AI选品报告弹窗 -->
    <transition name="ai-dialog-fade">
      <div v-if="reportDialogVisible" class="ai-dialog" @click.self="reportDialogVisible = false">
        <div class="ai-dialog__panel ai-dialog__panel--report">
          <div class="ai-dialog__header">
            <h3 class="ai-dialog__title">AI选品报告</h3>
            <button type="button" class="ai-dialog__close" @click="reportDialogVisible = false">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                <path d="M6 6l12 12M18 6L6 18"></path>
              </svg>
            </button>
          </div>

          <div class="ai-dialog__body">
            <section class="ai-report">
              <h4 class="ai-report__section-title">市场概况</h4>
              <div class="ai-report__overview">
                当前夏季女装连衣裙市场热度持续攀升，1688平台相关SKU超过120万件。法式碎花和气质收腰为主流风格，占市场份额约45%。建议重点关注50-80元价格带，该区间竞争度适中、转化率最高，预计月销可达500+件。
              </div>

              <h4 class="ai-report__section-title">热门价格带</h4>
              <div class="ai-report__bands">
                <div v-for="band in priceBands" :key="band.label" class="ai-report__band">
                  <span class="ai-report__band-label">{{ band.label }}</span>
                  <div class="ai-report__bar-track">
                    <i class="ai-report__bar-fill" :class="'ai-report__bar-fill--' + band.type" :style="{ width: band.percent + '%' }"></i>
                  </div>
                  <span class="ai-report__band-percent" :class="'is-' + band.type">{{ band.percent }}%</span>
                </div>
              </div>

              <h4 class="ai-report__section-title">推荐商品 TOP10</h4>
              <div class="ai-report__table">
                <div class="ai-report__thead">
                  <span>排名</span>
                  <span>商品</span>
                  <span>价格</span>
                  <span>月销量</span>
                  <span>推荐指数</span>
                </div>
                <div v-for="(item, index) in topList" :key="index" class="ai-report__row">
                  <span class="ai-report__rank">
                    <i v-if="index < 3" class="ai-report__rank-badge">{{ index + 1 }}</i>
                    <template v-else>{{ index + 1 }}</template>
                  </span>
                  <template v-if="item.name">
                    <span class="ai-report__name">{{ item.name }}</span>
                    <span class="ai-report__price">¥{{ item.price }}</span>
                    <span class="ai-report__sales">{{ item.sales }}</span>
                    <span class="ai-report__score">
                      <i :style="{ width: item.score + '%' }"></i>
                      <em>{{ item.score }}</em>
                    </span>
                  </template>
                  <span v-else class="ai-report__skeleton" :style="{ width: item.barWidth }"></span>
                </div>
              </div>

              <h4 class="ai-report__section-title">采购建议</h4>
              <div class="ai-report__advice">
                <p v-for="(tip, i) in adviceList" :key="i">
                  <span class="ai-report__pin">📌</span>
                  <span v-html="tip"></span>
                </p>
              </div>
            </section>
          </div>

          <div class="ai-dialog__footer">
            <button type="button" class="ai-dialog-btn ai-dialog-btn--gold">↓ 导出PDF</button>
            <button type="button" class="ai-dialog-btn ai-dialog-btn--cyan">↓ 导出Excel</button>
            <button type="button" class="ai-dialog-btn ai-dialog-btn--plain" @click="reportDialogVisible = false">关闭</button>
          </div>
        </div>
      </div>
    </transition>

    <!-- 以图搜货弹窗 -->
    <transition name="ai-dialog-fade">
      <div v-if="imgDialogVisible" class="ai-dialog" @click.self="imgDialogVisible = false">
        <div class="ai-dialog__panel ai-dialog__panel--img">
          <div class="ai-dialog__header ai-dialog__header--bordered">
            <h3 class="ai-dialog__title">以图搜货</h3>
            <button type="button" class="ai-dialog__close" @click="imgDialogVisible = false">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                <path d="M6 6l12 12M18 6L6 18"></path>
              </svg>
            </button>
          </div>

          <div class="ai-dialog__body">
            <div class="ai-upload" @click="triggerUpload" @dragover.prevent @drop.prevent="handleDrop">
              <input ref="imgFileInput" type="file" accept="image/jpeg,image/png,image/webp" class="ai-upload__input" @change="handleFileChange" />
              <div class="ai-upload__icon">🖼️</div>
              <p class="ai-upload__text">点击或拖拽上传商品图片</p>
              <p class="ai-upload__tip">支持 JPG / PNG / WebP，最大 5MB</p>
            </div>

            <div class="ai-form-item">
              <div class="ai-form-item__label">
                <span>搜索相似度</span>
                <b>{{ similarity }}%</b>
              </div>
              <input
                v-model.number="similarity"
                type="range"
                min="50"
                max="100"
                class="ai-range"
                :style="{ background: 'linear-gradient(to right, #e0b254 0%, #e0b254 ' + similarity + '%, #ffffff ' + similarity + '%, #ffffff 100%)' }"
              />
              <div class="ai-range__scale">
                <span>50%</span>
                <span>100%</span>
              </div>
            </div>

            <div class="ai-form-item ai-form-item--inline">
              <span class="ai-form-item__label-text">搜索数量</span>
              <input v-model.number="searchCount" type="number" min="1" max="100" class="ai-count-input" />
              <span class="ai-form-item__unit">件</span>
            </div>
          </div>

          <div class="ai-dialog__footer ai-dialog__footer--right">
            <button type="button" class="ai-dialog-btn ai-dialog-btn--plain" @click="imgDialogVisible = false">取消</button>
            <button type="button" class="ai-dialog-btn ai-dialog-btn--gold">开始搜索</button>
          </div>
        </div>
      </div>
    </transition>
    <under-development ref="underDevelopmentRef"></under-development>
  </div>
</template>

<script>
import UnderDevelopment from "@/components/newUi/UnderDevelopment.vue";

export default {
  name: 'SetAiWork',
  components: {UnderDevelopment},
  data() {
    return {
      inputText: '',
      reportDialogVisible: false,
      imgDialogVisible: false,
      similarity: 60,
      searchCount: 20,
      goodsList: [
        { id: 1, icon: '👗', title: '法式碎花连衣裙女夏季气质显瘦', price: '68.00' },
        { id: 2, icon: '🌸', title: '气质收腰连衣裙女夏季新款', price: '85.50' },
        { id: 3, icon: '🎀', title: '雪纺连衣裙女中长款碎花', price: '59.90' }
      ],
      hotList: [
        { id: 1, icon: '👚', title: '冰丝防晒衣女夏季轻薄透气防晒线', price: '35.00' },
        { id: 2, icon: '🩳', title: '男士冰丝短裤夏季宽松运动薄款', price: '28.50' },
        { id: 3, icon: '👙', title: '儿童泳衣女童连体裙式游泳衣', price: '45.00' }
      ],
      trendTags: [
        { name: '防晒衣', type: 'gold' },
        { name: '冰丝', type: 'normal' },
        { name: '碎花裙', type: 'normal' },
        { name: '速干', type: 'normal' },
        { name: '凉鞋', type: 'blue' },
        { name: '短裤', type: 'normal' },
        { name: 'T恤', type: 'gold' },
        { name: '连衣裙', type: 'normal' },
        { name: '背心', type: 'normal' },
        { name: '遮阳帽', type: 'normal' }
      ],
      recentList: [
        { id: 1, keyword: '女装连衣裙', time: '2小时前' },
        { id: 2, keyword: '男装T恤', time: '5小时前' },
        { id: 3, keyword: '防晒衣', time: '昨天' },
        { id: 4, keyword: '童装套装', time: '2天前' },
        { id: 5, keyword: '运动鞋', time: '3天前' }
      ],
      powerList: [
        { name: 'AI选品搜索', value: '800' },
        { name: '以图搜货', value: '500' },
        { name: '选品报告', value: '450' }
      ],
      priceBands: [
        { label: '50-80元', percent: 45, type: 'gold' },
        { label: '80-120元', percent: 30, type: 'cyan' },
        { label: '30-50元', percent: 25, type: 'purple' }
      ],
      topList: [
        { name: '法式碎花连衣裙', price: '68', sales: '2,340', score: 98 },
        { name: '气质收腰连衣裙', price: '85', sales: '1,890', score: 95 },
        { name: '雪纺连衣裙中长款', price: '59', sales: '1,650', score: 91 },
        { barWidth: '88%' },
        { barWidth: '80%' },
        { barWidth: '75%' },
        { barWidth: '69%' },
        { barWidth: '63%' },
        { barWidth: '57%' },
        { barWidth: '51%' }
      ],
      adviceList: [
        '建议优先采购法式碎花和气质收腰风格，价格控制在 <b>50-80元</b> 区间。',
        '来源优先选择评分 ≥4.8、发货率 ≥95% 的1688供应商。',
        '建议初次采购量 <b>50-100件</b> 测款，爆款可追加至500件+。',
        '关注竞争对手铺货时机，在大促前2周完成备货。'
      ]
    }
  },
  mounted() {
    this.$nextTick(this.$refs.underDevelopmentRef.show)
  },
  methods: {
    sendMessage() {
      this.inputText = ''
    },
    clearChat() {},
    triggerUpload() {
      this.$refs.imgFileInput && this.$refs.imgFileInput.click()
    },
    handleFileChange(e) {
      // 选择图片后的逻辑预留
      const file = e.target.files && e.target.files[0]
      if (file) {
        // 待接口对接
      }
    },
    handleDrop(e) {
      const file = e.dataTransfer.files && e.dataTransfer.files[0]
      if (file) {
        // 待接口对接
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$gold: #d4a03c;
$gold-dark: #c28f28;
$gold-light: #f6ecd8;
$blue: #4a9ff5;
$text-main: #333333;
$text-sub: #999999;
$bot-bubble: #f6f1e6;
$bot-bubble-border: #eee5d2;
$user-bubble: #e8f4fc;
$user-bubble-border: #d9ecf9;
$panel-border: #efe9dd;

.ai-work {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 600px;
  padding: 14px 16px 16px;
  background: #f4f5f7;
  box-sizing: border-box;
  overflow: hidden;

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-shrink: 0;
    margin-bottom: 12px;
  }

  &__title {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    color: $text-main;
    line-height: 1.3;
  }

  &__subtitle {
    margin: 4px 0 0;
    font-size: 13px;
    color: $text-sub;
  }

  &__header-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-top: 4px;
  }

  &__balance {
    height: 30px;
    line-height: 30px;
    padding: 0 14px;
    font-size: 13px;
    color: $gold-dark;
    background: $gold-light;
    border: 1px solid #ecd9b4;
    border-radius: 15px;
    box-sizing: border-box;

    b {
      margin-left: 4px;
      font-weight: 700;
    }
  }

  &__recharge {
    height: 30px;
    padding: 0 18px;
    font-size: 13px;
    color: $blue;
    background: #fff;
    border: 1px solid #b9d8f5;
    border-radius: 15px;
    cursor: pointer;

    &:hover {
      border-color: $blue;
    }
  }

  &__body {
    flex: 1;
    min-height: 0;
    display: flex;
    gap: 14px;
  }
}

/* ============ 左侧对话区 ============ */
.ai-chat {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid $panel-border;
  border-radius: 10px;
  overflow: hidden;

  &__top {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    border-bottom: 1px solid #f3efe6;
  }

  &__assistant {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__assistant-avatar {
    position: relative;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: linear-gradient(145deg, #e0b254, #cf9833);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 6px rgba(212, 160, 60, 0.35);
  }

  &__robot {
    font-size: 22px;
    line-height: 1;
  }

  &__online-dot {
    position: absolute;
    right: 0;
    bottom: 1px;
    width: 9px;
    height: 9px;
    background: #52c41a;
    border: 2px solid #fff;
    border-radius: 50%;
    box-sizing: content-box;
  }

  &__assistant-name {
    font-size: 15px;
    font-weight: 700;
    color: $gold-dark;
  }

  &__assistant-status {
    margin-top: 2px;
    font-size: 12px;
    color: #8a8f98;

    i {
      display: inline-block;
      width: 6px;
      height: 6px;
      margin-right: 4px;
      background: #52c41a;
      border-radius: 50%;
      vertical-align: 1px;
    }
  }

  &__clear {
    font-size: 13px;
    color: #9aa0aa;
    cursor: pointer;

    &:hover {
      color: $gold;
    }
  }

  &__messages {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 18px;
  }

  &__more {
    display: inline-block;
    margin-top: 10px;
    font-size: 13px;
    color: $blue;
    cursor: pointer;
  }

  /* 输入栏 */
  &__input {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 16px 14px;
    padding: 8px 10px 8px 8px;
    background: #fff;
    border: 1px solid #e7e1d3;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  }

  &__input-icon {
    flex-shrink: 0;
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #8b8678;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      color: $gold;
      background: $gold-light;
    }
  }

  &__input-field {
    flex: 1;
    min-width: 0;
    height: 38px;
    font-size: 14px;
    color: $text-main;
    background: transparent;
    border: none;
    outline: none;

    &::placeholder {
      color: #c2bdaf;
    }
  }

  &__send {
    flex-shrink: 0;
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: linear-gradient(145deg, #e0b254, #cf9833);
    border: none;
    border-radius: 50%;
    box-shadow: 0 3px 8px rgba(212, 160, 60, 0.4);
    cursor: pointer;

    &:hover {
      background: linear-gradient(145deg, #e6bb60, #d49e38);
    }
  }
}

/* ============ 消息气泡 ============ */
.ai-msg {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 20px;

  &--user {
    flex-direction: row;
    justify-content: flex-end;
  }

  &__avatar {
    flex-shrink: 0;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;

    &--bot {
      background: linear-gradient(145deg, #e0b254, #cf9833);
      box-shadow: 0 2px 5px rgba(212, 160, 60, 0.3);
    }

    &--user {
      color: #fff;
      font-size: 14px;
      font-weight: 600;
      background: linear-gradient(145deg, #3f74b3, #2c5a96);
      box-shadow: 0 2px 5px rgba(44, 90, 150, 0.3);
    }
  }

  &__main {
    max-width: 72%;
    min-width: 0;
  }

  &__meta {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
    font-size: 12px;

    &--user {
      justify-content: flex-end;
    }
  }

  &__name {
    color: $gold-dark;
    font-weight: 600;

    &--user {
      color: $blue;
    }
  }

  &__time {
    color: #a8aeb8;
  }

  &__bubble {
    display: inline-block;
    padding: 12px 14px;
    font-size: 13px;
    line-height: 1.7;
    border-radius: 10px;
    box-sizing: border-box;

    p {
      margin: 0;
    }

    &--bot {
      color: #4a463d;
      background: $bot-bubble;
      border: 1px solid $bot-bubble-border;
    }

    &--user {
      color: #2f5a82;
      background: $user-bubble;
      border: 1px solid $user-bubble-border;
    }

    &--analysis {
      display: flex;
      align-items: flex-start;
      gap: 6px;

      b {
        color: #333;
      }
    }
  }

  &__ask {
    margin-top: 8px !important;
  }

  &__bulb {
    flex-shrink: 0;
    line-height: 1.7;
  }

  &__actions {
    display: flex;
    gap: 10px;
    margin-top: 10px;
  }
}

.ai-btn {
  height: 30px;
  padding: 0 16px;
  font-size: 13px;
  border-radius: 5px;
  cursor: pointer;

  &--gold {
    color: #fff;
    background: linear-gradient(145deg, #e0b254, #cf9833);
    border: 1px solid #c9942f;

    &:hover {
      background: linear-gradient(145deg, #e6bb60, #d49e38);
    }
  }

  &--plain {
    color: $blue;
    background: #fff;
    border: 1px solid #b9d8f5;

    &:hover {
      border-color: $blue;
    }
  }
}

/* ============ 对话内商品卡片 ============ */
.ai-goods {
  display: flex;
  gap: 12px;
  margin-top: 12px;

  &__item {
    width: 168px;
    flex-shrink: 0;
    padding: 0 0 10px;
    background: #fff;
    border: 1px solid #eee8da;
    border-radius: 8px;
    overflow: hidden;
    transition: box-shadow 0.2s;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
  }

  &__img {
    height: 104px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #838891;

    span {
      font-size: 40px;
      line-height: 1;
    }
  }

  &__title {
    height: 38px;
    margin: 8px 10px 4px;
    font-size: 12px;
    line-height: 1.6;
    color: #4a463d;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__price {
    margin: 0 10px 8px;
    font-size: 15px;
    font-weight: 700;
    color: $gold-dark;
  }

  &__add {
    display: block;
    width: calc(100% - 20px);
    height: 28px;
    margin: 0 10px;
    font-size: 12px;
    color: #fff;
    background: linear-gradient(145deg, #e0b254, #cf9833);
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background: linear-gradient(145deg, #e6bb60, #d49e38);
    }
  }
}

/* ============ 右侧面板 ============ */
.ai-aside {
  flex-shrink: 0;
  width: 40%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
}

.ai-panel {
  flex-shrink: 0;
  background: #fff;
  border: 1px solid $panel-border;
  border-radius: 10px;
  overflow: hidden;

  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px 0;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 15px;
    font-weight: 700;
    color: $gold-dark;
  }

  &__icon {
    font-size: 15px;
  }

  &__link {
    font-size: 13px;
    color: $blue;
    cursor: pointer;
  }

  &__body {
    padding: 12px 16px 14px;
  }
}

/* AI热门推荐 */
.ai-hot {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px dashed #f0eade;

  &:last-child {
    border-bottom: none;
    padding-bottom: 2px;
  }

  &__img {
    flex-shrink: 0;
    width: 54px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    background: #fff;
    border-radius: 8px;
  }

  &__info {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-size: 13px;
    line-height: 1.5;
    color: #4a463d;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__price {
    margin-top: 5px;
    font-size: 15px;
    font-weight: 700;
    color: $gold-dark;
  }

  &__btn {
    flex-shrink: 0;
    height: 28px;
    padding: 0 12px;
    font-size: 12px;
    color: $gold-dark;
    background: #fff;
    border: 1px solid #e3c489;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
      color: #fff;
      background: $gold;
      border-color: $gold;
    }
  }
}

/* 市场趋势 */
.ai-trend {
  &__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 12px;
  }

  &__tag {
    font-size: 14px;
    line-height: 1.6;
    color: #6b6659;
    cursor: pointer;

    &--gold {
      font-size: 17px;
      font-weight: 700;
      color: $gold-dark;
    }

    &--blue {
      font-size: 16px;
      font-weight: 700;
      color: $blue;
    }

    &:hover {
      opacity: 0.8;
    }
  }

  &__time {
    margin-top: 10px;
    font-size: 12px;
    color: #a8aeb8;
  }
}

/* 最近搜索 */
.ai-recent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 13px;

  &__keyword {
    color: #4a463d;
    font-weight: 600;
    cursor: pointer;

    &:hover {
      color: $gold-dark;
    }
  }

  &__time {
    color: #a8aeb8;
    font-size: 12px;
  }
}

/* AI算力消耗 */
.ai-power {
  &__used {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    font-size: 13px;
    color: #8a8f98;

    b {
      font-size: 15px;
      color: $gold-dark;

      em {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        color: #a8aeb8;
      }
    }
  }

  &__bar {
    height: 6px;
    margin: 10px 0 6px;
    background: #f1efe8;
    border-radius: 3px;
    overflow: hidden;

    i {
      display: block;
      height: 100%;
      background: linear-gradient(90deg, #e0b254, #cf9833);
      border-radius: 3px;
    }
  }

  &__list {
    margin-top: 6px;
  }

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    font-size: 13px;
    color: #8a8f98;
    border-bottom: 1px solid #f4f1ea;

    span:last-child {
      color: $gold-dark;
      font-weight: 600;
    }
  }

  &__detail {
    display: inline-block;
    margin-top: 8px;
  }
}

/* ============ 深色弹窗通用 ============ */
$dialog-bg: #101f3d;
$dialog-border: #28385e;
$dialog-text: #e9e2cf;
$dialog-muted: #8fa0c4;
$dialog-gold: #dcb256;
$dialog-cyan: #3fc3e8;

.ai-dialog {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: rgba(8, 15, 32, 0.78);
  box-sizing: border-box;

  &__panel {
    display: flex;
    flex-direction: column;
    max-height: 88vh;
    background: $dialog-bg;
    border: 1px solid $dialog-border;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
    overflow: hidden;

    &--report {
      width: 720px;
      max-width: 100%;
    }

    &--img {
      width: 640px;
      max-width: 100%;
    }
  }

  &__header {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;

    &--bordered {
      border-bottom: 1px solid #223155;
    }
  }

  &__title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: $dialog-text;
    letter-spacing: 1px;
  }

  &__close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    color: #9fb0d2;
    background: transparent;
    border: none;
    border-radius: 6px;
    cursor: pointer;

    &:hover {
      color: #fff;
      background: rgba(255, 255, 255, 0.08);
    }
  }

  &__body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 4px 24px 8px;
  }

  &__footer {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    padding: 16px 24px 22px;

    &--right {
      justify-content: flex-end;
      padding-top: 18px;
      border-top: 1px solid #223155;
    }
  }
}

.ai-dialog-fade-enter-active,
.ai-dialog-fade-leave-active {
  transition: opacity 0.22s ease;

  .ai-dialog__panel {
    transition: transform 0.22s ease, opacity 0.22s ease;
  }
}

.ai-dialog-fade-enter,
.ai-dialog-fade-leave-to {
  opacity: 0;

  .ai-dialog__panel {
    transform: translateY(14px) scale(0.98);
    opacity: 0;
  }
}

/* 弹窗按钮 */
.ai-dialog-btn {
  height: 38px;
  padding: 0 22px;
  font-size: 14px;
  border-radius: 7px;
  cursor: pointer;
  box-sizing: border-box;

  &--gold {
    color: #fff;
    background: linear-gradient(145deg, #e2b75b, #d09e3d);
    border: 1px solid #c99a3c;
    font-weight: 600;

    &:hover {
      background: linear-gradient(145deg, #e8c16c, #d8a844);
    }
  }

  &--cyan {
    color: $dialog-cyan;
    background: transparent;
    border: 1px solid rgba(63, 195, 232, 0.65);

    &:hover {
      background: rgba(63, 195, 232, 0.1);
    }
  }

  &--plain {
    color: $dialog-muted;
    background: transparent;
    border: 1px solid #3a4b73;

    &:hover {
      color: #fff;
      border-color: #5a6f9e;
    }
  }
}

/* ============ AI选品报告 ============ */
.ai-report {
  padding-bottom: 14px;

  &__section-title {
    position: relative;
    margin: 20px 0 12px;
    padding-left: 10px;
    font-size: 16px;
    font-weight: 700;
    color: $dialog-gold;
    line-height: 1.3;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 2px;
      bottom: 2px;
      width: 4px;
      background: $dialog-gold;
      border-radius: 2px;
    }
  }

  &__overview {
    padding: 16px 18px;
    font-size: 14px;
    line-height: 1.9;
    color: #555a66;
    background: #fff;
    border-radius: 8px;
  }

  /* 热门价格带 */
  &__bands {
    padding: 4px 10px 0;
  }

  &__band {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__band-label {
    flex-shrink: 0;
    width: 72px;
    font-size: 14px;
    color: $dialog-muted;
    text-align: right;
  }

  &__bar-track {
    flex: 1;
    height: 22px;
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
  }

  &__bar-fill {
    display: block;
    height: 100%;
    border-radius: 4px;

    &--gold {
      background: linear-gradient(90deg, #e8cf94, #d4a63f);
    }

    &--cyan {
      background: linear-gradient(90deg, #9fe0f2, #3fc3e8);
    }

    &--purple {
      background: linear-gradient(90deg, #b7aaf8, #8b7cf6);
    }
  }

  &__band-percent {
    flex-shrink: 0;
    width: 42px;
    font-size: 15px;
    font-weight: 700;

    &.is-gold {
      color: $dialog-gold;
    }

    &.is-cyan {
      color: $dialog-cyan;
    }

    &.is-purple {
      color: #a99cff;
    }
  }

  /* TOP10 表格 */
  &__table {
    border: 1px solid #233355;
    border-radius: 8px;
    overflow: hidden;
  }

  &__thead,
  &__row {
    display: grid;
    grid-template-columns: 56px 1fr 90px 100px 140px;
    align-items: center;
  }

  &__thead {
    height: 42px;
    padding: 0 14px;
    font-size: 13px;
    font-weight: 600;
    color: $dialog-muted;
    background: rgba(255, 255, 255, 0.03);
    box-sizing: border-box;
  }

  &__row {
    min-height: 44px;
    padding: 8px 14px;
    font-size: 14px;
    color: #c4d0e6;
    border-top: 1px solid #1b2947;
    box-sizing: border-box;
  }

  &__rank {
    color: #6f80a4;
    font-size: 14px;
  }

  &__rank-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    font-style: normal;
    font-size: 13px;
    font-weight: 700;
    color: #5a4310;
    background: linear-gradient(145deg, #e8c97e, #d4a63f);
    border-radius: 5px;
  }

  &__name {
    color: #8fa0c4;
  }

  &__price {
    color: $dialog-gold;
    font-weight: 700;
  }

  &__sales {
    color: #c4d0e6;
  }

  &__score {
    display: flex;
    align-items: center;
    gap: 8px;

    i {
      width: 70px;
      height: 4px;
      background: linear-gradient(90deg, #e8cf94, #d4a63f);
      border-radius: 2px;
    }

    em {
      font-style: normal;
      font-size: 13px;
      color: $dialog-gold;
    }
  }

  &__skeleton {
    grid-column: 2 / 3;
    height: 12px;
    background: #fff;
    border-radius: 6px;
  }

  /* 采购建议 */
  &__advice {
    padding: 14px 18px;
    background: #f6f1e6;
    border-radius: 8px;

    p {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      margin: 0;
      padding: 5px 0;
      font-size: 14px;
      line-height: 1.7;
      color: #5d5749;

      b {
        color: $gold-dark;
        font-weight: 700;
      }
    }
  }

  &__pin {
    flex-shrink: 0;
    line-height: 1.7;
  }
}

/* ============ 以图搜货 ============ */
.ai-upload {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  margin: 22px 0 24px;
  border: 2px dashed #c9a14e;
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;

  &:hover {
    border-color: $dialog-gold;
    background: rgba(220, 178, 86, 0.05);
  }

  &__input {
    display: none;
  }

  &__icon {
    width: 74px;
    height: 74px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 38px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid #3a4b73;
    border-radius: 14px;
  }

  &__text {
    margin: 18px 0 8px;
    font-size: 17px;
    color: #7d8cab;
  }

  &__tip {
    margin: 0;
    font-size: 14px;
    color: #63739a;
  }
}

.ai-form-item {
  margin-bottom: 22px;

  &--inline {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
    padding-bottom: 22px;
    border-bottom: 1px solid #223155;
  }

  &__label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    font-size: 15px;
    color: #7d8cab;

    b {
      font-size: 18px;
      color: $dialog-gold;
    }
  }

  &__label-text {
    font-size: 15px;
    color: #7d8cab;
  }

  &__unit {
    font-size: 15px;
    color: #b7c3db;
  }
}

.ai-msg__bubble--user {
  color: rgb(212, 169, 70);
}
.ai-work__title{
  color: rgb(212, 169, 70);
}

.ai-range {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 6px;
  margin: 0;
  border-radius: 3px;
  outline: none;
  cursor: pointer;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    background: $dialog-gold;
    border: 2px solid #fff;
    border-radius: 50%;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.45);
  }

  &::-moz-range-thumb {
    width: 14px;
    height: 14px;
    background: $dialog-gold;
    border: 2px solid #fff;
    border-radius: 50%;
  }

  &__scale {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
    font-size: 13px;
    color: #63739a;
  }
}

.ai-count-input {
  width: 110px;
  height: 44px;
  padding: 0 12px;
  font-size: 18px;
  font-weight: 600;
  color: $dialog-gold;
  text-align: center;
  background: #fff;
  border: none;
  border-radius: 8px;
  outline: none;
  box-sizing: border-box;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

/* 滚动条美化 */
.ai-chat__messages::-webkit-scrollbar,
.ai-aside::-webkit-scrollbar,
.ai-dialog__body::-webkit-scrollbar {
  width: 6px;
}

.ai-chat__messages::-webkit-scrollbar-thumb,
.ai-aside::-webkit-scrollbar-thumb {
  background: #e0dccd;
  border-radius: 3px;
}

.ai-dialog__body::-webkit-scrollbar-thumb {
  background: #2c3d63;
  border-radius: 3px;
}
</style>
